module.exports = __webpack_public_path__ + "static/media/ceilings-002.77c78bc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/ceilings-002.jpg
// module id = 90
// module chunks = 0